import useFaqComponent from "./useFaqComponent";
import {createClass} from "../../utils/helper";

export default function faqComponent ({index="",title = "", content = ""}) {
   const {dropdown , toggleDropdown} = useFaqComponent();
    return (

            <div className={createClass("wcs-item", !dropdown ? "" : "wcs-active")} key={index}>
                <a className="wcs-item-q" onClick={toggleDropdown} >
                    {title}
                </a>
                <div className="wcs-item-ans" style={dropdown ? {display : 'block'} : {display : 'none'}}>
                    {content}
                </div>
            </div>

        )
}


